import {
  FC,
  useEffect,
  createContext,
  useContext,
  ReactNode,
  useReducer,
  useState,
  useRef,
  Dispatch,
} from 'react';

import {WithChildren} from '../../../_metronic/helpers'

import {chatState, initialState, chatReducer} from './reducer';
import {ActionTypes, setChats} from './actions';
import { chatAPI } from '../../api'
import { SplashLogo } from '../../components/Logo'
import { useAuth } from '../auth'
import { UserType } from '../../models'

interface ChatContextProps {
  state: chatState;
  dispatch: Dispatch<ActionTypes>;
}

const ChatContext = createContext<ChatContextProps | undefined>(undefined)


const useChat = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  return context;
}

const ChatProvider: FC<WithChildren> = ({children}) => {
  const [state, dispatch] = useReducer(chatReducer, initialState);

  return (
    <ChatContext.Provider value={{state, dispatch}}>
      {children}
    </ChatContext.Provider>
  )
}

interface ChatInitProps {
  children: ReactNode;
}

const ChatInit: FC<ChatInitProps> = ({children}) => {
  const {dispatch} = useChat()
  const didRequest = useRef(false)
  const [showSplashScreen, setShowSplashScreen] = useState(true)
  const { currentUser } = useAuth()

  useEffect(() => {
    const requestList = async () => {
      try {
        if (!didRequest.current) {
          const {data: data} = await chatAPI.getAll()
          dispatch(setChats(data['data']))
        }
      } catch (error) {
        console.error(error)
      } finally {
        setShowSplashScreen(false)
      }
      return () => (didRequest.current = true)
    }
    currentUser?.email ? requestList() : setShowSplashScreen(false)
  }, [currentUser])

  return showSplashScreen ? 
    <SplashLogo/>
    : 
    <>{children}</>
}

export {ChatProvider, ChatInit, useChat}
